// src/components/admin/Reports.js
import React from 'react';
import { BarChart3, Download, FileText, PieChart } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

const Reports = () => {
    const { isDarkMode } = useTheme();
    const reports = [
        { id: 1, name: 'Monthly Payroll Report', type: 'Payroll', lastGenerated: '2025-01-05' },
        { id: 2, name: 'Attendance Analytics', type: 'Attendance', lastGenerated: '2025-01-08' },
        { id: 3, name: 'Department Overview', type: 'HR', lastGenerated: '2025-01-07' },
        { id: 4, name: 'Performance Summary', type: 'Performance', lastGenerated: '2024-12-31' }
    ];

    return (
        <div className="space-y-6">
            <h1 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                Reports & Analytics
            </h1>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {reports.map(report => (
                    <div
                        key={report.id}
                        className={`${isDarkMode ? 'bg-gray-800 border border-gray-700' : 'bg-white shadow'} rounded-lg p-6`}
                    >
                        <div className="flex items-start justify-between">
                            <div className="flex items-center gap-3">
                                <FileText className={`w-8 h-8 ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`} />
                                <div>
                                    <h3 className={`font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                                        {report.name}
                                    </h3>
                                    <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                        {report.type}
                                    </p>
                                    <p className={`text-xs ${isDarkMode ? 'text-gray-500' : 'text-gray-400'} mt-1`}>
                                        Last generated: {new Date(report.lastGenerated).toLocaleDateString()}
                                    </p>
                                </div>
                            </div>
                            <button className={`${isDarkMode ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-800'}`}>
                                <Download className="w-5 h-5" />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Reports;